import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Page } from "@digital-services/shell";
import { Typography } from "@digital-services/ui";

import Dashboard from "@dashboard/pages/Dashboard";

import { useUserContext } from "@hooks/useUserContext";

export const HomePage: FunctionComponent = () => {
  const { t } = useTranslation(undefined, { keyPrefix: "home" });
  const { user } = useUserContext();

  return (
    <Page title="Home">
      <Typography variant="smallTitle">
        {t("page_title", { userName: user.name })}
      </Typography>
      <Dashboard />
    </Page>
  );
};
